import React from 'react'

const Skills = () => {
    return (
        <div className="bg-dark container-fluid pt-5 mb-5 mt-5">
            <h2 className="text-center text-white">Mis <span className="text-primary">Fortalezas</span></h2>
            <div className="row bg-dark justify-content-center pt-2">
                <div className="col-md-6">
                    <p className="text-center text-white text-secondary">
                        Entre mis competencias se resaltan las siguientes que pueden verse en movimiento tanto en este Sitio Web que estas visitando como en mi portafolio.
                        <h6>¡Gracias por tu interés!</h6>

                    </p>
                </div>
            </div>

            <div className="row bg-secondary text-secondary pt-5 text-white paddingRBL-5">
                <div className="col-md-6">
                    <div>
                        <div className="display-flex justify-content-space-between">
                            <span>HTML5</span>
                            <span>80%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-80"></div>
                        </div>
                    </div>
                    <div className="space-top-lg">
                        <div className="display-flex justify-content-space-between">
                            <span>CSS 3</span>
                            <span>70%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-70"></div>
                        </div>
                    </div>
                    <div className="space-top-lg">
                        <div className="display-flex justify-content-space-between">
                            <span>JavaScript</span>
                            <span>80%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-80"></div>
                        </div>
                    </div>
                    <div className="space-top-lg">
                        <div className="display-flex justify-content-space-between">
                            <span>React</span>
                            <span>85%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-85"></div>
                        </div>
                    </div>
                    <div className="space-top-lg">
                        <div className="display-flex justify-content-space-between">
                            <span>Angular</span>
                            <span>80%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-80"></div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div>
                        <div className="display-flex justify-content-space-between">
                            <span>Python</span>
                            <span>80%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-80"></div>
                        </div>
                    </div>
                    <div className="space-top-lg">
                        <div className="display-flex justify-content-space-between">
                            <span>FastAPI</span>
                            <span>80%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-80"></div>
                        </div>
                    </div>
                    <div className="space-top-lg">
                        <div className="display-flex justify-content-space-between">
                            <span>Django</span>
                            <span>70%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-70"></div>
                        </div>
                    </div>
                    <div className="space-top-lg">
                        <div className="display-flex justify-content-space-between">
                            <span>Node.js</span>
                            <span>75%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-75"></div>
                        </div>
                    </div>
                    <div className="space-top-lg">
                        <div className="display-flex justify-content-space-between">
                            <span>MongoDB</span>
                            <span>80%</span>
                        </div>
                        <div className="progress-container space-top">
                            <div className="progress percent-80"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skills
